<template>
  <v-dialog v-model="is_AddKakaoChannel" max-width="500px">
    <v-card class="add-kakao-channel">
      <v-card-title class="pt-5 pl-5 pb-1 font-weight-bold">카카오채널 추가</v-card-title>
      <v-card-text class="pl-5 pb-0">
        카카오 알림톡 발송을 위해서 카카오톡 채널을 추가합니다.<br />
        카카오채널 관리자에 등록된 핸드폰 번호만 인증 가능합니다.<br />
        (카카오채널 아이디가 없다면 <a href="https://business.kakao.com/dashboard/" target="_blank">신규가입</a> 후 등록합니다)<br />
      </v-card-text>
      <v-card-text class="mt-5">
        <span class="subtitle-2 font-weight-bold black--text">카카오채널 검색용 아이디</span>
        <v-text-field
          outlined
          dense
          hide-details="false"
          prepend-inner-icon="@"
          v-model="kakaoChannelId"
          placeholder="카카오 채널 이름"
          class="mb-5 kakao_id_text"
        ></v-text-field>
        <span class="subtitle-2 font-weight-bold black--text">카카오채널 관리자 핸드폰번호</span>
        <div>
          <v-col cols="12" class="d-flex justify-space-between pa-0 mb-1">
            <v-text-field
              type="tel"
              outlined
              dense
              hide-details="false"
              v-model="kakaoAuthPhone"
              placeholder="카카오 관리자 핸드폰 번호"
            ></v-text-field>
            <v-btn ref="sendAuthBtn" color="grey darken-1 ml-2" height="40px" class="white--text send_auth_btn" @click="sendAuthCode"
              >인증번호 전송</v-btn
            >
          </v-col>
          <a href="https://center-pf.kakao.com/settings/account" target="_blank">카카오채널 관리자 핸드폰번호 확인하기</a>
        </div>
        <v-row>
          <v-col v-show="is_kakaoAuthCode">
            <v-text-field outlined dense hide-details="false" v-model="kakaoAuthCode"></v-text-field>
            <span class="grey--text text-xs">카카오톡으로 전송된 6자리 인증번호를 입력 후 아래 ‘추가하기’를 클릭하세요.</span>
          </v-col>
          <v-col v-show="is_ExtraInfo" class="pb-0">
            <span class="grey--text text-xs" v-html="text_extrainfo"></span>
          </v-col>
        </v-row>
        <v-card-actions class="d-flex justify-space-between mt-5 pa-0 ">
          <div style="width:49%;">
            <v-btn color="grey darken-4" block class="white--text" @click="is_AddKakaoChannel = false">닫기</v-btn>
          </div>
          <div style="width:49%;">
            <v-btn color="yellow darken-1" block class="" @click="addKakaoChannel">카카오채널 추가하기</v-btn>
          </div>
        </v-card-actions>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<style>
.text-decoration-underline {
  text-decoration: underline;
  cursor: pointer;
}

.add-kakao-channel .text-xs {
  font-size: 12px;
}

.add-kakao-channel .kakao_id_text i,
.add-kakao-channel .kakao_id_text .v-input__icon i,
.add-kakao-channel .kakao_id_text .v-icon {
  font-style: normal !important;
  font-size: 16px !important;
}
</style>

<script>
import M from "@/libs/mapping.js";
import CommonMixin from "@/mixins/CommonMixin.js";
export default {
  data() {
    return {
      is_AddKakaoChannel: false,
      is_kakaoAuthCode: false,
      kakaoChannelId: "",
      kakaoAuthPhone: "",
      kakaoAuthCode: "",
      checkAuthId: "",
      checkAuthPhone: "",
      kakaoSenderKey: "",
      is_ExtraInfo: false,
      text_extrainfo: "",
    };
  },
  methods: {
    validateInput() {
      if (!this.kakaoChannelId) {
        this.alertShow("카카오채널 검색용 아이디를 입력해주세요.");
        return false;
      } else if (!this.kakaoAuthPhone) {
        this.alertShow("카카오채널 관리자 핸드폰번호를 입력해주세요.");
        return false;
      }
      return true;
    },
    openAddKakaoChannelModal() {
      this.is_AddKakaoChannel = true;
      this.initInput();
    },
    initInput: function() {
      this.kakaoChannelId = "";
      this.kakaoAuthPhone = "";
      this.kakaoAuthCode = "";
      this.is_kakaoAuthCode = false;
      this.is_ExtraInfo = false;
      this.text_extrainfo = "";
    },
    addKakaoChannel() {
      //this.$emit("changeUseSetting", this.switchValue);
      if (!this.validateInput()) {
        return;
      } else {
        // console.log("check", this.kakaoSenderKey);
        if (!this.is_kakaoAuthCode && !this.kakaoSenderKey) {
          this.alertShow("핸드폰 번호 인증이 필요합니다.");
        } else if (this.kakaoAuthCode.length < 6 && !this.kakaoSenderKey) {
          this.alertShow("인증번호를 입력해주세요.");
        } else {
          // API call to add kakao channel
          this.authConfirm();
        }
      }
    },
    authConfirm: async function() {
      // API call to confirm auth code
      try {
        const res = await M.api(M.entry("/post/channel/kakao/verify"), {
          id: this.kakaoChannelId,
          hp: this.kakaoAuthPhone,
          code: this.kakaoAuthCode,
          sender_key: this.kakaoSenderKey,
        });
        if (res.status == 0) {
          this.alertShow("인증이 완료되었습니다.");
          this.is_kakaoAuthCode = false;
          this.is_AddKakaoChannel = false;
          this.kakaoAuthCode = "";
          await this.$emit("get-kakao");
        } else if (res.status == "copy") {
          this.alertShow(res.message);
          this.kakaoAuthCode = "";
          this.is_kakaoAuthCode = false;
          this.is_AddKakaoChannel = false;
          await this.$emit("get-kakao");
        } else {
          this.alertShow(res.message);
          this.kakaoAuthCode = "";
          this.is_kakaoAuthCode = false;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async sendAuthCode() {
      if (!this.validateInput()) {
        return;
      }
      try {
        // API call to send auth code
        const res = await M.api(M.entry("/post/config/kakao/auth"), {
          id: this.kakaoChannelId,
          hp: this.kakaoAuthPhone,
        });
        if (res.status != 0) {
          if (res.status == -99 && res.senderKey) {
            // 이미 인증된 채널아이디 존재
            this.text_extrainfo = "이미 인증된 채널로 아래 ‘추가하기’를 클릭해 주세요.";
            this.is_ExtraInfo = true;
            this.kakaoSenderKey = res.senderKey;
          }
          this.alertShow(res.message);
          return;
        } else {
          this.alertShow("인증번호가 전송되었습니다.");
          this.kakaoAuthCode = "";
          this.is_kakaoAuthCode = true;
          this.$refs.sendAuthBtn.$el.innerText = "인증번호 재전송";
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  mixins: [CommonMixin],
};
</script>
